import dayjs from '../../utilities/dayjs'

export const validate = (isRecurring) => {
  return function (values) {
    const errors = {}

    if (!values.ticketTypeId) {
      errors.ticketTypeId = 'Required'
    }

    if (!values.resourceTypeId) {
      errors.resourceType = 'Required'
    }

    if (!values.billingStatus) {
      errors.billingStatus = 'Required'
    }

    if (values.requestedStartTime && !values.requestedEndTime) {
      errors.requestedEndTime = 'Required if Start Time'
    }

    if (values.requestedEndTime && !values.requestedStartTime) {
      errors.requestedStartTime = 'Required if End Time'
    }

    const formattedRequestedStartTime = dayjs(values.requestedStartTime, 'HH:mm')
    const formattedRequestedEndTime = dayjs(values.requestedEndTime, 'HH:mm')
    const invalidTimes =
      values.requestedStartTime &&
      values.requestedEndTime &&
      formattedRequestedEndTime.isBefore(formattedRequestedStartTime)
    const sameTimes =
      values.requestedStartTime &&
      values.requestedEndTime &&
      formattedRequestedEndTime.isSame(formattedRequestedStartTime)

    if (invalidTimes || sameTimes) {
      errors.requestedEndTime = 'End Time must be after Start Time'
      errors.requestedStartTime = 'Start Time must be before End Time'
    }

    if (isRecurring) {
      const { serviceInterval, startDate, serviceDay = [], serviceDate, serviceDailyFrequency } = values

      if (!serviceInterval) {
        errors.serviceInterval = 'Required'
      }

      if (!startDate) {
        errors.startDate = 'Required'
      }

      if (serviceInterval === 'MONTHLY' && !serviceDate.length) {
        errors.serviceDate = 'Required'
      }

      if (serviceInterval === 'EVERY_X_DAYS') {
        if (!serviceDailyFrequency) errors.serviceDailyFrequency = 'Required'
        if (serviceDailyFrequency < 1) errors.serviceDailyFrequency = 'Value must be at least 1'
      }

      if (serviceInterval === 'WEEKLY' && !serviceDay.length) {
        errors.serviceDay = 'Required'
      }
    }
    return errors
  }
}
